/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Archive_DoneInputs */

const cs_property_archive_done = /** @type {(inputs: Property_Archive_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost archivována a skryta na webu.`)
};

const en_property_archive_done = /** @type {(inputs: Property_Archive_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property archived and hidden on the website.`)
};

/**
* | output |
* | --- |
* | "Property archived and hidden on the website." |
*
* @param {Property_Archive_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_archive_done = /** @type {((inputs?: Property_Archive_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Archive_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_archive_done(inputs)
	return cs_property_archive_done(inputs)
});